import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

var KeycloakInfo = /** @class */ (function (_super) {
    __extends(KeycloakInfo, _super);
    function KeycloakInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeycloakInfo.prototype, "message", {
        get: function () {
            return this.kcContext.message;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakInfo.prototype, "actionUri", {
        get: function () {
            return this.kcContext.actionUri;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakInfo.prototype, "baseUrl", {
        get: function () {
            return this.kcContext.client.baseUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakInfo.prototype, "skipLink", {
        get: function () {
            return this.kcContext.skipLink;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakInfo.prototype, "pageRedirectUri", {
        get: function () {
            return this.kcContext.pageRedirectUri;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakInfo.prototype, "kcContext", void 0);
    KeycloakInfo = __decorate([
        Component({
            name: 'corex-keycloak-info',
        })
    ], KeycloakInfo);
    return KeycloakInfo;
}(Mixins(MagicConfigMixin)));

export default KeycloakInfo;
